<template>
  <div>
    <div v-if="loading" class="loading-bar">
      <atom-spinner
        :animation-duration="1000"
        :size="60"
        color="#ff1d5e"
        class="mx-auto"
      />
    </div>
    <div>
      <vx-card>
        <div>
          <vs-table
            :max-items="paginationItems[1]"
            pagination
            :data="vouchers"
            :description="false"
            search
            @selected="handleSelected"
            :description-items="paginationItems"
            description-title="Registries"
            description-connector="of"
            description-body="Pages"
          >
            <template slot="header">
              <div class="list-heading">
                {{ $t("setup.label.SIMNumbers") }}
              </div>
              <div class="mr-2 mb-1 order-1">
                <vs-button
                  icon-pack="feather"
                  icon="icon-plus"
                  @click="$router.push({ name: 'Create SIM Number' })"
                  size="small"
                  >{{ $t("setup.label.CreateSIMNumber") }}</vs-button
                >
              </div>
            </template>
            <template slot="thead">
              <vs-th>{{ $t("setup.label.BatchName") }}</vs-th>
              <vs-th>{{ $t("setup.label.NumberCategory") }}</vs-th>
              <vs-th>{{ $t("setup.label.Length") }}</vs-th>
              <vs-th>{{ $t("setup.label.BeginWith") }}</vs-th>
              <vs-th>{{ $t("setup.label.Quantity") }}</vs-th>
              <vs-th>{{ $t("setup.label.NumberType") }}</vs-th>
              <vs-th>{{ $t("setup.label.Value") }}</vs-th>
              <vs-th>{{ $t("setup.label.ExpiryDate") }}</vs-th>
              <vs-th class="tHeadCenter">{{ $t("setup.label.Actions") }}</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr
                :key="index"
                :data="voucher"
                v-for="(voucher, index) in data"
              >
                <vs-td :data="voucher.batchName">{{ voucher.batchName }}</vs-td>
                <vs-td :data="voucher.pinCategory">{{
                  voucher.pinCategory
                }}</vs-td>
                <vs-td :data="voucher.length">{{ voucher.length }}</vs-td>
                <vs-td :data="voucher.beginWith">{{ voucher.beginWith }}</vs-td>
                <vs-td :data="voucher.quantity">{{ voucher.quantity }}</vs-td>
                <vs-td :data="voucher.pinType">{{ voucher.pinType }}</vs-td>
                <vs-td :data="voucher.pinValue">{{
                  voucher.pinType === "PRODUCT"
                    ? voucher.planCode
                    : voucher.pinValue
                }}</vs-td>
                <vs-td :data="voucher.expiryDate">{{
                  getDate(voucher.expiryDate)
                }}</vs-td>

                <vs-td class="whitespace-no-wrap">
                  <div class="container_img">
                    <feather-icon
                      v-if="voucher.isProcessed === 'Y'"
                      icon="DownloadIcon"
                      :title="$t('setup.label.Download')"
                      class="text-warning icon_row"
                      svgClasses="w-5 h-5 stroke-current cursor"
                      @click.stop="download(voucher.id)"
                    />
                    <feather-icon
                      v-if="voucher.isProcessed === 'N'"
                      icon="PlayIcon"
                      :title="$t('setup.label.Process')"
                      class="text-success icon_row"
                      svgClasses="w-5 h-5 stroke-current cursor"
                      @click.stop="process(voucher.id)"
                    />
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </vx-card>
    </div>
  </div>
</template>
<script>
import { mapState } from "vuex";
import moment from "moment";
import { AtomSpinner } from "epic-spinners";
import { BUCKET_BASE_URL } from "@/http/index";

export default {
  data() {
    return {
      loading: false,
      paginationItems: [5, 10, 15],
    };
  },
  components: { AtomSpinner },
  computed: {
    ...mapState({
      vouchers: (state) => state.voucherPin.voucherList,
      formattedDate: (state) => state.settings.selectedDateFormat,
    }),
  },
  methods: {
    async getvoucherList() {
      this.loading = true;
      await this.$store.dispatch("voucherPin/setVoucherList");
      this.loading = false;
    },
    handleSelected(item) {
      this.$router.push({ name: "Voucher Pins", params: { id: item.id } });
    },
    getDate(date) {
      if (date) {
        const d = new Date(date);
        return moment(d).format(this.formattedDate);
      }
      return null;
    },
    download(id) {
      window.open(BUCKET_BASE_URL + `/vouchers/${id}?tenantIdentifier=default`);
    },

    async process(id) {
      let payload = { voucherId: id };
      await this.$store.dispatch("voucherPin/processVoucherAc", payload);

      this.getvoucherList();
    },
  },
  mounted() {
    this.getvoucherList();
  },
};
</script>
<style lang="scss" scoped>
.vs-table--search {
  max-width: 100%;
  margin-left: 0px !important;
}

.vuesax-app-is-ltr .vs-table--search {
  margin-left: 0;
}

.vs-search-categeory {
  margin-top: 17px;
}
</style>
